import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";

export default ({ data }) => {
  return (
    <div className="chart-container">
      <ResponsiveContainer>
        <BarChart data={data}>
          <XAxis dataKey="initials"/>
          <YAxis/>
          <CartesianGrid strokeDasharray="3 3"/>
          <Tooltip/>
          <Bar name="Reuniões" dataKey="count" stackId="a" fill="#9cc177" />
        </BarChart>
      </ResponsiveContainer>

      <style jsx>{`
        .chart-container {
          width: 100%;
          height: 400px;
        }
      `}</style>
    </div>
  );
}



// WEBPACK FOOTER //
// components/stats/PerDepartmentStats.js